/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { L10nIntlService, L10nNumberPipe, L10nTranslationService } from 'angular-l10n';
import { DataTypes } from './enums/data-type.enum';

@Injectable()
export class DataTypePipesService {
  private translation = inject(L10nTranslationService);
  private intl = inject(L10nIntlService);

  private pipes: {
    decimal: L10nNumberPipe;
    percentage: L10nNumberPipe;
  };
  dl: string;

  constructor() {
    const intl = this.intl;

    this.dl = this.translation.getLocale().language;
    this.pipes = {
      decimal: new L10nNumberPipe(intl),
      percentage: new L10nNumberPipe(intl),
    };
  }

  /**
   * Devuelve un dato cualquiera según su el tipo que se haya establecido en la gráfica
   * Añade el formato a los números, divisas, porcentajes... según el locale
   * @param value valor a dar formato
   * @param dataType tipo de datos según el cual se va a formatear
   */
  getStringFormattedData(rawvalue: any, dataType?: any, compact = false): string {
    const value = parseFloat(rawvalue);

    if (isNaN(value)) {
      return this.replaceNaN(rawvalue);
    } else if (dataType) {
      switch (dataType.name) {
        case DataTypes.currency: {
          const val = this.replaceNaN(
            new Intl.NumberFormat(this.translation.getLocale().language, {
              ...(compact ? { notation: 'compact' } : {}),
              ...(dataType.decimals !== null
                ? {
                    minimumFractionDigits: dataType.decimals,
                    maximumFractionDigits: dataType.decimals,
                  }
                : {}),
            }).format(value)
          );
          return compact ? `${val}` : `${val} (mixed currency)`;
        }

        case DataTypes.number: {
          const val = this.replaceNaN(
            new Intl.NumberFormat(this.translation.getLocale().language, {
              ...(dataType.decimals !== null
                ? {
                    minimumFractionDigits: dataType.decimals,
                    maximumFractionDigits: dataType.decimals,
                  }
                : {}),
              ...(compact ? { notation: 'compact' } : {}),
            }).format(value)
          );

          return dataType.measurementUnit && dataType.measurementUnit !== 'number'
            ? `${val} ${this.translation.translate(dataType.measurementUnit)}`
            : `${val}`;
        }
        case DataTypes.percentage:
          return `${this.replaceNaN(
            new Intl.NumberFormat(this.translation.getLocale().language, {
              ...(dataType.decimals !== null
                ? {
                    minimumFractionDigits: dataType.decimals,
                    maximumFractionDigits: dataType.decimals,
                  }
                : {}),
              ...(compact ? { notation: 'compact' } : {}),
            }).format(value * 100)
          )}%`;
        case DataTypes.date:
          return 'date';
        // return this.parseDate(rawvalue, dataType);
        default: {
          return 'default';
          // return this.replaceNaN(this.pipes.decimal.transform(value, this.dl));
        }
      }
    } else {
      return 'no hay';
      // return this.replaceNaN(this.pipes.decimal.transform(value, this.dl));
    }
  }

  replaceNaN(value: string | number): string {
    if (Number.isNaN(value) || value === 'NaN' || value === null || value === undefined) {
      return '-';
    } else {
      return value.toString();
    }
  }

  // parseDate(value: string, dataType?: any): string {
  //   let readFormat = 'MMM';
  //   let dateFormat: string;
  //   if (dataType && dataType.temporalSegment === 'temporal-segment-quarter') {
  //     dateFormat = `YYYY [${this.translation.translate('$chart.quarter-letter')}]Q`;
  //     readFormat = 'YYYY Q';
  //   } else if (dataType && dataType.temporalSegment === 'temporal-segment-semester') {
  //     dateFormat = `YYYY [${this.translation.translate('$chart.semester-letter')}]Q`;
  //     readFormat = 'YYYY Q';
  //   } else if (dataType && dataType.temporalSegment === 'temporal-segment-year') {
  //     dateFormat = `YYYY`;
  //     readFormat = 'YYYY';
  //   } else if (dataType && dataType.temporalSegment === 'temporal-segment-month') {
  //     dateFormat = `MMM YY`;
  //     readFormat = 'YYYY M';
  //   } else if (dataType && dataType.temporalSegment === 'temporal-segment-week') {
  //     dateFormat = `[${this.translation.translate('$chart.week-letter')}]W YY`;
  //     readFormat = 'YYYY W';
  //   } else if (dataType && dataType.temporalSegment === 'temporal-segment-day') {
  //     dateFormat = `D MMM YY`;
  //   } else {
  //     dateFormat = 'D MMM YY';
  //   }
  //   return moment(value, readFormat).format(dateFormat);
  // }
}
